import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMicrophoneOff: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="microphone-off"><path d="M16.25 11.75V7.25C16.25 4.90279 14.3472 3 12 3C10.6334 3 9.41741 3.64504 8.63994 4.64727M5.12407 14.75C6.2814 17.3989 8.92453 19.25 12 19.25C13.7832 19.25 15.4211 18.6277 16.7083 17.5883M12 21.5L12 19.5M7.75 8.75V11.75C7.75 14.0972 9.65279 16 12 16C12.8956 16 13.7264 15.723 14.4116 15.25M3 3.25L7.75 8L21 21.25L3 3.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMicrophoneOff;
